export interface DatosGeneralesProyecto {
    idproyecto: number;
    tituloProyecto: string;
    codigoProyecto: string;
    fechaInicio: Date;
    fechaFinal: Date;
    objetivoGeneral: string;
}

export function VoidDatosGeneralesProyecto(): DatosGeneralesProyecto {
    return{
        idproyecto: 0,
        tituloProyecto: '',
        codigoProyecto: '',
        fechaInicio: new Date(),
        fechaFinal: new Date(),
        objetivoGeneral: ''
    }
};